import * as R from 'ramda';
import loadingStateType from 'utils/ts/LoadingStateType';

// Render fns that match up to loadingState types
interface renderTypes {
  // Must have at least success, or what's the point?
  SUCCESS();
  NOT_LOADED?();
  LOADING?();
  FAILURE?();
}

// A no-render noop, since React lets you render 'null'
const noRender = () => null;

/**
 * Calls a render function that matches the current loadingStateType, e.g.
 * 'SUCCESS'. Useful as an alternative to an HOC (withLoadingError), for
 * instance inside render methods.
 */
const renderLoadState = (renderFns: renderTypes) =>
  ({ state = 'NOT_LOADED' }: loadingStateType) => (
    R.propOr(noRender, state, renderFns)()
  );

export default renderLoadState;

